import { useContext, useState } from "react";

import { useQuery } from "@tanstack/react-query";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { getPackages } from "services/Package.services";

import { AuthTokenContext } from "components/AuthProvider/AuthProviderContext";

export default function usePackage() {
  const token = useContext(AuthTokenContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const form = useFormContext();

  const handleChosePackage = (pkgId: string) => {
    form.setValue("packageId", pkgId);
    searchParams.set("tab", "method");
    setSearchParams(searchParams);
  };

  const handleOpenContact = (pkgId: string) => {
    form.setValue("packageId", pkgId);
    setIsOpen(true);
  };

  const { i18n } = useTranslation();

  const { data: packages, isLoading: isPackagesLoading } = useQuery<any>({
    queryKey: ["packages"],
    queryFn: () => getPackages({ locale: i18n.language }),
    enabled: !!token,
  });

  return { packages, isPackagesLoading, form, handleChosePackage, handleOpenContact, isOpen, setIsOpen };
}
